/**
 * TabComponent.js
 * Handles the functionality for tab components in the bundler
 */

export class TabComponent {
  /**
   * Initialize tabs within a container
   * @param {HTMLElement} container - The container element that holds the tabs
   */
  static initializeProductTabs(container) {
    // Find all tab buttons within the container
    const tabButtons = container.querySelectorAll('[data-tab-toggle]');
    
    tabButtons.forEach(function(button) {
      // Add click listener for tab buttons
      button.addEventListener('click', TabComponent.toggleTab);
    });
  }
  
  /**
   * Toggle tab visibility
   * @param {Event} event - The click event
   */
  static toggleTab(event) {
    const button = this;
    const tabName = button.getAttribute('data-tab-toggle');
    const container = button.closest('.tabs-container').parentNode;
    const wasActive = button.classList.contains('active');
    
    // Toggle active state on tab buttons
    const tabButtons = container.querySelectorAll('[data-tab-toggle]');
    tabButtons.forEach(btn => btn.classList.remove('active'));
    
    // Toggle panels
    const tabPanels = container.querySelectorAll('[data-tab-panel]');
    
    if (wasActive) {
      // Hide all panels when closing
      tabPanels.forEach(panel => {
        panel.style.display = 'none';
      });
    } else {
      // Show the corresponding panel when opening
      button.classList.add('active');
      tabPanels.forEach(panel => {
        panel.style.display = panel.getAttribute('data-tab-panel') === tabName ? 'block' : 'none';
      });
    }
  }
  
  /**
   * Global click handler for tab buttons
   * @param {Event} event - The click event
   */
  static handleGlobalClick(event) {
    // Handle tab buttons
    if (event.target.hasAttribute('data-tab-toggle') || event.target.closest('[data-tab-toggle]')) {
      const button = event.target.hasAttribute('data-tab-toggle') ? 
                    event.target : 
                    event.target.closest('[data-tab-toggle]');
      
      // Call the toggle function with the button as context
      TabComponent.toggleTab.call(button);
    }
  }
}

// Add global click handler
document.addEventListener('click', TabComponent.handleGlobalClick);

// Expose the initialization function to the global scope for use in Liquid templates
window.initializeProductTabs = TabComponent.initializeProductTabs; 